{
  "permissions": {
    "admin_devices": "Admin Devices",
    "manage_dashboards": "Manage Dashboards",
    "manage_devices": "Manage Devices",
    "manage_organizations": "Manage Organizations",
    "manage_reports": "Manage Reports",
    "manage_shared_dashboards": "Manage Shared Dashboards",
    "manage_tokens": "Manage API Keys",
    "manage_users": "Manage Users",
    "read_dashboards": "Read Dashboards",
    "read_devices": "Read Devices",
    "read_organizations": "Read Organizations",
    "read_reports": "Read Reports",
    "read_users": "Read Users"
  }
}